{
    "RTE_Label": "Fangen Sie an zu tippen...",
    "NAME": "RichTextEditor"
}